export enum WebsiteUrlEn {
  Discord = 'https://discord.com/invite/roolna',
  Facebook = 'https://www.facebook.com/OFFICIALRagnarokOriginROO',
  Twitter = 'https://twitter.com/Ragnarok_NA',
  Youtube = 'https://www.youtube.com/channel/UCJi72qp6wBRnre_pspNdSWA',
  Tiktok = 'https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1',
  Instagram = 'https://www.instagram.com/ragnarokorigin_en',
  Kwai = 'https://k.kwai.com/u/@roobr/CebkjM6n',
}
export enum WebsiteUrlEs {
  Discord = 'https://discord.com/invite/roolna',
  Facebook = 'https://www.facebook.com/RagnarokOriginROOSP',
  Twitter = 'https://twitter.com/RagnaOrigin_ES',
  Youtube = 'https://www.youtube.com/@RagnarokOriginLATAM',
  Tiktok = 'https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1',
  Instagram = 'https://www.instagram.com/latamragnarokorigin',
  Kwai = 'https://k.kwai.com/u/@roobr/CebkjM6n',
}

/* 【葡萄牙】 跳转链接 */
export enum WebsiteUrlPt {
  Discord = 'https://discord.com/invite/roolna',
  Facebook = 'https://www.facebook.com/RagnarokOriginROOPT',
  Twitter = 'https://twitter.com/RagnaOrigin_BR',
  Youtube = 'https://www.youtube.com/@RagnarokOriginBR',
  Tiktok = 'https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1',
  Instagram = 'https://www.instagram.com/ragnarokorigin_br',
  Kwai = 'https://k.kwai.com/u/@roobr/CebkjM6n',
}

/* 【英语】 跳转链接 */
export enum WebsiteUrlSea {
  Discord = 'https://discord.gg/rooglobal',
  Facebook = 'https://www.facebook.com/rooglobal',
  Twitter = 'https://twitter.com/GlobalRagnarok',
  Youtube = 'https://www.youtube.com/channel/UC63jl9OHPZgb5yBR6h5IncQ',
  Tiktok = 'https://www.tiktok.com/@ragnarok_origin_global',
}

/* 【印尼】 跳转链接 */
export enum WebsiteUrlId {
  Discord = 'https://discord.gg/rooglobal',
  Facebook = 'https://www.facebook.com/RagnarokOriginIndonesia',
  Twitter = 'https://twitter.com/GlobalRagnarok',
  Youtube = 'https://www.youtube.com/@RagnarokOriginSEA',
  Tiktok = 'https://www.tiktok.com/@ragnarok_origin_id',
}

/* 【泰国】 跳转链接 */
export enum WebsiteUrlTh {
  Discord = 'https://discord.gg/rooglobal',
  Facebook = 'https://www.facebook.com/RagnarokOriginThailandOfficial',
  Twitter = 'https://twitter.com/GlobalRagnarok',
  Youtube = 'https://www.youtube.com/@RagnarokOriginTH',
  Tiktok = 'https://www.tiktok.com/@ragnarok_origin_th',
}

export enum WebsiteUrlTc {
  Facebook = 'https://lihi1.com/jIoPL',
  Line = 'https://lihi1.com/e72an',
  Youtube = 'https://www.youtube.com/@Ragnarok_Origin',
  Discord = 'https://lihi1.com/BLGIW',
  Bahamut = 'https://lihi1.com/xEsyk',
}

export enum ChannelUrlSea {
  Ios = 'https://apps.apple.com/us/app/ragnarok-origin-global/id1661507061',
  GooglePlay = 'https://play.google.com/store/apps/details?id=com.gravity.roo.sea',
  Windows = 'https://ro-cdn-sea-cf.roglobal.com/package/pc_download.html',
  Apk = 'https://ro-cdn-sea-cf.roglobal.com/package/apk_download.html',
  Pay = '/shopStore/selectOrder',
  PayMobile = '/m/shopStore/selectOrder',
  Gleam = 'https://gleam.io/7BrwV/roo-preregistration-event-1-million-ingame-items-huawei-phones-await',
  Huawei = 'https://appgallery.cloud.huawei.com/ag/n/orderappdetail/C107769719',
  Oppo = 'oaps://mk/dt?id=30968199',
  Razer = 'https://gold.razer.com/gold/catalog/ragnarok-origin',
}

export enum ChannelUrlHmt {
  Ios = 'https://apps.apple.com/tw/app/id1618358912',
  GooglePlay = 'https://play.google.com/store/apps/details?id=com.gravity.roo.tw',
  Apk = 'https://cdn-tc-hmt-tx.huanle.com/ro-official-hmt/web/apk_download.html',
  MyCardPay = 'https://www.gnjoy.hk/billing',
  Windows = 'https://roo.gnjoy.hk/static/download/roo_launcher.exe',
}

export enum ChannelUrlLna {
  Ios = 'https://apps.apple.com/us/app/ragnarok-origin-roo/id6459411007',
  GooglePlay = 'https://play.google.com/store/apps/details?id=com.gravity.roo.lna',
  Windows = 'https://ro-cdn-lna-cf.roglobal.com/package/download.html',
  Apk = 'https://ro-cdn-lna-cf.roglobal.com/package/download.html?type=apk',
  Pay = '/shopStore/selectOrder',
  PayMobile = '/m/shopStore/selectOrder',
  Gleam = 'https://gleam.io/7BrwV/roo-preregistration-event-1-million-ingame-items-huawei-phones-await',
  Huawei = 'https://appgallery.huawei.com/app/C109740441',
  Oppo = 'oaps://mk/dt?id=30968199',
  Razer = 'https://gold.razer.com/gold/catalog/ragnarok-origin',
}


export const DownloadUrlMap = {
  hmt: ChannelUrlHmt,
  lna: ChannelUrlLna,
  sea: ChannelUrlSea,
};


export const WebsiteUrlMap = {
  cn: WebsiteUrlEn,
  en: WebsiteUrlEn,
  es: WebsiteUrlEs,
  id: WebsiteUrlId,
  pt: WebsiteUrlPt,
  tc: WebsiteUrlTc,
  th: WebsiteUrlTh,
};

enum WebsiteUrlSeaEn {
  Discord = 'https://discord.gg/rooglobal',
  Facebook = 'https://www.facebook.com/OFFICIALRagnarokOriginROO',
  Twitter = 'https://twitter.com/Ragnarok_NA',
  Youtube = 'https://www.youtube.com/@RagnarokOriginGlobal',
  Tiktok = 'https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1',
  Instagram = 'https://www.instagram.com/ragnarokorigin_en',
  Kwai = 'https://k.kwai.com/u/@roobr/CebkjM6n',
};

enum WebsiteUrlSeaCn {
  Discord = 'https://discord.gg/rooglobal',
  Facebook = 'https://www.facebook.com/OFFICIALRagnarokOriginROO',
  Twitter = 'https://twitter.com/Ragnarok_NA',
  Youtube = 'https://www.youtube.com/@RagnarokOriginGlobal',
  Tiktok = 'https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1',
  Instagram = 'https://www.instagram.com/ragnarokorigin_en',
  Kwai = 'https://k.kwai.com/u/@roobr/CebkjM6n',
};

enum WebsiteUrlSeaTc {
  Discord = 'https://discord.gg/rooglobal',
  Facebook = 'https://www.facebook.com/OFFICIALRagnarokOriginROO',
  Twitter = 'https://twitter.com/Ragnarok_NA',
  Youtube = 'https://www.youtube.com/@RagnarokOriginGlobal',
  Tiktok = 'https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1',
  Instagram = 'https://www.instagram.com/ragnarokorigin_en',
  Kwai = 'https://k.kwai.com/u/@roobr/CebkjM6n',
};

enum WebsiteUrlSeaId {
  Discord = 'https://discord.gg/rooglobal',
  Facebook = 'https://www.facebook.com/RagnarokOriginIndonesia',
  Twitter = 'https://twitter.com/Ragnarok_NA',
  Youtube = 'https://www.youtube.com/@RagnarokOriginIndonesia',
  Tiktok = 'https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1',
  Instagram = 'https://www.instagram.com/ragnarokorigin_en',
  Kwai = 'https://k.kwai.com/u/@roobr/CebkjM6n',
};

enum WebsiteUrlSeaTh {
  Discord = 'https://discord.gg/rooglobal',
  Facebook = 'https://www.facebook.com/RagnarokOriginThailandOfficial',
  Twitter = 'https://twitter.com/Ragnarok_NA',
  Youtube = 'https://www.youtube.com/@RagnarokOriginTH',
  Tiktok = 'https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1',
  Instagram = 'https://www.instagram.com/ragnarokorigin_en',
  Kwai = 'https://k.kwai.com/u/@roobr/CebkjM6n',
};

export const getWebsiteUrl = () => {
  const platform = import.meta.env.VITE_APP_PLATFORM;
  switch (platform) {
    case 'lna': 
    return {
      cn: WebsiteUrlEn,
      en: WebsiteUrlEn,
      es: WebsiteUrlEs,
      id: WebsiteUrlId,
      pt: WebsiteUrlPt,
      tc: WebsiteUrlTc,
      th: WebsiteUrlTh,
    };
    case 'hmt':
    return {
      cn: WebsiteUrlEn,
      en: WebsiteUrlEn,
      es: WebsiteUrlEs,
      id: WebsiteUrlId,
      pt: WebsiteUrlPt,
      tc: WebsiteUrlTc,
      th: WebsiteUrlTh,
    };
    case 'sea':
    return {
      cn: WebsiteUrlSeaCn,
      en: WebsiteUrlSeaEn,
      es: WebsiteUrlEs,
      id: WebsiteUrlSeaId,
      pt: WebsiteUrlPt,
      tc: WebsiteUrlSeaTc,
      th: WebsiteUrlSeaTh,
    };
    default: 
    return {
      cn: WebsiteUrlEn,
      en: WebsiteUrlEn,
      es: WebsiteUrlEs,
      id: WebsiteUrlId,
      pt: WebsiteUrlPt,
      tc: WebsiteUrlTc,
      th: WebsiteUrlTh,
    };
  }
};